// extracted by mini-css-extract-plugin
module.exports = {"bn":"CardsBD_bn__3CC9U","en":"CardsBD_en__2fMK6"};